/** Builds a query string, skipping undefined/null/empty values. Keys are sorted for stable URLs. */
export function buildQuery(params: Record<string, string | number | null | undefined>): string {
  const usp = new URLSearchParams();
  for (const key of Object.keys(params).sort()) {
    const v = params[key];
    if (v === undefined || v === null || v === "") continue;
    usp.set(key, String(v));
  }
  const s = usp.toString();
  return s ? `?${s}` : "";
}
